import { Store } from '@webtides/element-js';

export default class ProductCompareStore extends Store {
    /** @type {HTMLElement[]} */
    items = [];

    /** @type {number[]} */
    rowHeights = [];

    /** @type {number} */
    headerHeight = 0;

    /** @type {boolean} */
    syncPending = false;

    /** @type {HTMLElement|null} */
    table = null;

    register(item) {
        if (!this.items.includes(item)) {
            this.items.push(item);
        }
        this.scheduleSyncHeights();
    }

    unregister(item) {
        this.items = this.items.filter((i) => i !== item);
        this.scheduleSyncHeights();
    }

    scheduleSyncHeights() {
        if (this.syncPending) return;
        this.syncPending = true;
        requestAnimationFrame(() => {
            this.syncPending = false;
            this.syncHeights();
        });
    }

    syncHeights() {
        this.items.forEach((item) => item.resetHeights());
        this.table?.resetSidebarHeights();

        let maxHeader = 0;
        const rowHeights = [];

        this.items.forEach((item) => {
            const m = item.getMeasurements();
            maxHeader = Math.max(maxHeader, m.headerHeight);
            m.rowHeights.forEach(({ index, height }) => {
                rowHeights[index] = Math.max(rowHeights[index] || 0, height);
            });
        });

        // Include sidebar row natural heights in the max calculation
        if (this.table) {
            const sidebarHeights = this.table.getSidebarMeasurements();
            sidebarHeights.forEach((height, index) => {
                rowHeights[index] = Math.max(rowHeights[index] || 0, height);
            });
        }

        this.headerHeight = maxHeader;
        this.rowHeights = rowHeights;

        this.items.forEach((item) => item.applyHeights(this.headerHeight, rowHeights));
        this.table?.applySidebarHeights(rowHeights);
        this.requestUpdate();
    }
}
